export const budgetFormatOptions = {
  compact: 'short',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
